import React from "react";
import { Link } from "react-router-dom"; // Utilisation de react-router pour navigation
import { useTranslation } from 'react-i18next';  
import "../../../i18n";

const ErrorPage500 = () => {
  const { t, i18n } = useTranslation(); 

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>{t("404title")}</h1>
      <p style={styles.message}>
        {t("400message")}
      </p>
      <Link to="/" style={styles.link}>{t('home_button')}</Link>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    padding: "50px",
    backgroundColor: "#fafaf2",
    borderRadius: "8px",
    margin: "100px auto",
    maxWidth: "600px",
  },
  title: {
    fontSize: "48px",
    fontWeight: "bold",
    color: "#d1001c",
  },
  message: {
    fontSize: "18px",
    color: "#d1001c",
    marginTop: "20px",
  },
  link: {
    display: "inline-block",
    marginTop: "30px",
    fontSize: "16px",
    color: "#d1001c",
    textDecoration: "none",
    border: "1px solid #d1001c",
    padding: "10px 20px",
    borderRadius: "5px",
    backgroundColor: "#fffff",
  },
};

export default ErrorPage500;
